import React from 'react';
import { Box, Text } from '@wix/design-system';
import s from './Content.scss';
import { Trans, useTranslation } from 'react-i18next';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import { RootStore, withInjectedRootStore } from '../../../../providers';
import { CirclePulseAnimation } from '@wix/package-picker-components';

interface SecondUpgradeProps {
  rootStore: RootStore;
}

export const SecondUpgradeComp: React.FC<SecondUpgradeProps> = ({
  rootStore,
}) => {
  const { t } = useTranslation();
  if (rootStore.appStore.appContext.availableCredit < 10) {
    return <Text className={s.withDash}>{t('app.second_upgrade_text')}</Text>;
  }

  return (
    <Box verticalAlign='middle' gap='6px'>
      <CirclePulseAnimation color='#60bc57' />
      <Text className={s.semiBold}>
        <PremiumCurrencyFormatter
          render={(formatCurrency) => {
            const { currentPlanDetails, availableCredit } =
              rootStore.appStore.appContext;
            const currentPlan = currentPlanDetails?.planName;
            const credit = formatCurrency(Math.floor(availableCredit), {
              hideZeroDecimals: true,
            });
            return (
              <Trans
                i18nKey='app.second_upgrade_optimization.subtitle'
                values={{ credit, currentPlan }}
                components={{
                  creditPart: <Text skin='success' weight='bold' />,
                }}
              ></Trans>
            );
          }}
        />
      </Text>
    </Box>
  );
};

export const SecondUpgrade = withInjectedRootStore(SecondUpgradeComp);
